import React, { useState, useEffect } from 'react';
import { ChevronRight, Play } from 'lucide-react';
import { Button } from './ui/button';
import { heroImages } from '../utils/mockData';

export const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Images with Fade Transition */}
      <div className="absolute inset-0 z-0">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={`Corporate cafe ${index + 1}`}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10 py-32 pt-40">
        <div className="max-w-3xl">
          <div className="animate-fade-in">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Taste First.
              <br />
              <span className="text-[#FE9E1C]">Health Bonus.</span>
              <br />
              Warmth Guaranteed.
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-4 font-medium">
              Balanced Bites Cafe is a new generation corporate cafe designed for modern workplaces.
            </p>
            <p className="text-lg md:text-xl text-white/80 mb-10">
              Chef curated food that keeps you going through the workday.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => scrollToSection('partner')}
                className="bg-[#FE9E1C] hover:bg-[#e68a0f] text-white px-8 py-6 text-lg font-semibold group transition-all duration-200 hover:scale-105"
              >
                Explore Partnerships
                <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={() => scrollToSection('menu')}
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-[#59642C] px-8 py-6 text-lg font-semibold backdrop-blur-sm transition-all duration-200"
              >
                See Menu
              </Button>
            </div>
          </div>

          {/* Image Indicators */}
          <div className="flex space-x-2 mt-12">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`h-1 rounded-full transition-all duration-300 ${
                  index === currentImageIndex ? 'w-12 bg-[#FE9E1C]' : 'w-8 bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full p-1">
          <div className="w-1.5 h-3 bg-white/60 rounded-full mx-auto"></div>
        </div>
      </div>
    </section>
  );
};
